// DynamicThemeProvider.js
import { ReactNode } from 'react';
import {
  ChakraProvider,
  ChakraProviderProps,
  theme as baseTheme,
  StyleFunctionProps,
  extendTheme,
} from '@chakra-ui/react';
import theme from './theme';
import { useMobile } from './hooks/useMobile';

export const DynamicThemeProvider = ({
  children,
  ...rest
}: { children: ReactNode } & ChakraProviderProps) => {
  const { isMobile } = useMobile();

  const customTheme = {
    ...theme,
    styles: {
      ...theme.styles,
      global: {
        ...theme.styles?.global,
        html: {
          ...theme.styles?.global?.html,
          overflow: isMobile ? 'auto !important' : '',
          touchAction: isMobile ? 'pan-y!important' : '',
        },
        body: {
          ...theme.styles?.global?.body,
          overflow: isMobile ? 'auto !important' : '',
          touchAction: isMobile ? 'pan-y!important' : '',
        },
      },
    },
    components: {
      ...theme.components,
      Button: {
        ...theme.components?.Button,
        baseStyle: {
          ...theme.components.Button.baseStyle,
          fontSize: isMobile ? '1.2rem' : 'md',
          h: isMobile ? '3.6rem' : '3rem',
        },
        variants: {
          ...theme.components.Button.variants,
          normal: {
            ...theme.components.Button.variants.normal,
            fontSize: isMobile ? '1.2rem' : 'md',
            h: isMobile ? '3.6rem' : '3rem',
            _hover: isMobile
              ? ''
              : theme.components.Button.variants.normal._hover,
          },
          darkSolid: {
            ...theme.components.Button.variants.darkSolid,
            fontSize: isMobile ? '1.2rem' : 'md',
            h: isMobile ? '3.6rem' : '3rem',
          },
          redSolid: {
            ...theme.components.Button.variants.redSolid,
            fontSize: isMobile ? '1.2rem' : 'md',
            h: isMobile ? '3.6rem' : '3rem',
          },
          outline: {
            ...theme.components.Button.variants.outline,
            fontSize: isMobile ? '1.2rem' : 'md',
            h: isMobile ? '3.6rem' : '3.25rem',
          },
          bigGreenOutline: {
            ...theme.components.Button.variants.bigGreenOutline,
            _hover: isMobile
              ? ''
              : theme.components.Button.variants.bigGreenOutline._hover,
          },
          bigRedOutline: {
            ...theme.components.Button.variants.bigRedOutline,
            _hover: isMobile
              ? ''
              : theme.components.Button.variants.bigRedOutline._hover,
          },
        },
      },
      NumberInput: {
        baseStyle: (props: StyleFunctionProps) => {
          const baseStyle = baseTheme.components.NumberInput.baseStyle?.(props);
          return {
            ...baseStyle,
            field: {
              ...baseStyle?.field,
              fontSize: isMobile ? '1.2rem' : 'md',
              h: isMobile ? '3.6rem' : '3rem',
              pl: '2',
              bg: 'transparent',
            },
          };
        },
      },
      Select: {
        baseStyle: (props: StyleFunctionProps) => {
          const baseStyle = baseTheme.components.Select.baseStyle;
          return {
            ...baseStyle,
            field: {
              ...baseStyle?.field,
              fontSize: isMobile ? '1.2rem' : 'md',
              h: isMobile ? '3.6rem' : 12,
              pl: '2',
              bg: 'transparent',
            },
          };
        },
      },
      Modal: {
        baseStyle: {
          overlay: {
            position: 'fixed',
            overflow: 'auto', // 确保不会阻止滚动
          },
          dialogContainer: {
            position: 'fixed',
            overflow: 'auto', // 确保不会阻止滚动
          },
        },
      },
    },
  };
  return (
    <ChakraProvider theme={extendTheme(customTheme)} {...rest}>
      {children}
    </ChakraProvider>
  );
};
